import { useEffect } from 'react';
import Mixpanel, { getEventName } from './handler';
import urlMatcher from './url-matcher';
export default function useTrackPageView({ props, trackDuration = true, screen, } = {}) {
    useEffect(() => {
        const fallbackScreen = screen ||
            urlMatcher.match(window.location.pathname) ||
            'Unknown';
        Mixpanel.trackPageView({
            screen: fallbackScreen,
            props,
            trackDuration,
        });
        return () => {
            Mixpanel.stopTrackDuration({
                eventName: getEventName({
                    screen: fallbackScreen,
                    action: 'Page View',
                }),
                props,
            });
        };
    }, [props, trackDuration, screen]);
}
